// apply this class to whatever element you want to right click on
// set the [id] of the element to be the id you want to use in the
// optionClickFunction
export const RIGHT_CLICKABLE_CLASS_NAME = 'right-clickable'